// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tIIe","label":"styles_label__71SH9"};